import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/context";
import { IboContext } from "../context/iboContext";
import { ProspectContext } from "../context/prospectContext";

const useContactRelation = () => {
  const { userInfoQursiva } = useContext(AuthContext);
  const { iboInfo } = useContext(IboContext);
  const { prospectInfo } = useContext(ProspectContext);

  // Sin sesión NI IBO, `iboInfo` es `undefined` en el provider — antes esta
  // línea crasheaba al montar cualquier componente que usara este hook desde
  // la home sin sesión (H reportado tras la 5.7). El optional chaining deja
  // token en `undefined`; el resto del hook ya lo maneja.
  const [token, setToken] = useState(
    userInfoQursiva ? userInfoQursiva.tokenQursiva : iboInfo?.tokenQursiva
  );
  const [idContactRelation, setIdContactRelation] = useState(undefined);
  const [userLocal, setUserLocal] = useState(undefined);

  const getContactRelationLocal = () => {
    if (userInfoQursiva) {
      setToken(userInfoQursiva.tokenQursiva);
    } else if (iboInfo) {
      setToken(iboInfo.tokenQursiva);
    }
  };

  const getIdContactRelation = () => {
    if (userInfoQursiva) {
      setUserLocal(userInfoQursiva);
      setIdContactRelation(userInfoQursiva.userRelationId);
    } else if (prospectInfo) {
      setUserLocal(prospectInfo);
      setIdContactRelation(prospectInfo.userRelationId);
    } else if (iboInfo) {
      setUserLocal(iboInfo);
      setIdContactRelation(iboInfo.userRelationId);
    }
  };

  useEffect(() => {
    getContactRelationLocal();
    getIdContactRelation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfoQursiva, iboInfo, prospectInfo]);

  return {
    token,
    idContactRelation,
    userLocal,
  };
};

export default useContactRelation;
